import React, { useState, useEffect } from "react";
import "../styles/Chatbotwidget.css";
import { MessageCircle } from "lucide-react";
import ChatBot from "../Components/ChatBot";

const ChatbotWidget = () => {
  const [open, setOpen] = useState(false);
  const [showLabel, setShowLabel] = useState(true);

  // Show/hide label repeatedly
  useEffect(() => {
    const interval = setInterval(() => {
      setShowLabel(true);

      setTimeout(() => {
        setShowLabel(false);
      }, 3000); // visible for 3 sec
    }, 6000); // repeat every 6 sec

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {!open && (
        <>
          {showLabel && (
            <div className="chatbot-label">
              Ask CodeMatrix AI Assistant 👋
            </div>
          )}

          <div
            className="chatbot-icon"
            onClick={() => setOpen(true)}
          >
            <MessageCircle size={28} />
          </div>
        </>
      )}

      {open && (
        <ChatBot closeChat={() => setOpen(false)} />
      )}
    </>
  );
};

export default ChatbotWidget;